/** Spring Boot serves the admin API under `/faastaa-admin`; ensure base URL includes it. */
export function resolveApiBaseUrl(): string {
    const base = (process.env.REACT_APP_URL ?? '').replace(/\/$/, '');
    if (!base) return '';
    return base.endsWith('/faastaa-admin') ? base : `${base}/faastaa-admin`;
}
